import { z } from 'zod';

export const commissionEarlyPayStatusEnum = z.enum(['NOT_ORDERED', 'NOT_OFFERED', 'PENDING', 'ACCEPTED', 'REJECTED']);
export type TCommissionEarlyPayStatus = z.infer<typeof commissionEarlyPayStatusEnum>;
